import { render, staticRenderFns } from "./NbRadio.vue?vue&type=template&id=81d93aee&"
import script from "./NbRadio.vue?vue&type=script&lang=js&"
export * from "./NbRadio.vue?vue&type=script&lang=js&"
import style0 from "./NbRadio.vue?vue&type=style&index=0&id=81d93aee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports